import React from 'react';
import {Descriptions, Typography} from 'antd';
import {useTranslation} from 'react-i18next';
import {standardDisplayValue} from './textAssetStandardValues';
import {normalizeTextAssetText} from './TextAssetText';

// Full asset detail includes the ordered schema for both legacy and v2 types.
// Only custom definitions supplied in that response may be rendered.
export default function TextAssetFields({asset, attrs, layout = 'horizontal', renderCustomField, renderStandardField}) {
    const {t} = useTranslation();
    const type = asset.entity_type;
    const customFields = new Map((type?.schema_custom_meta_fields || []).map(field => [field.id, field]));
    const fields = (type?.fields || []).filter(field => !field.custom_meta_field_id || customFields.has(field.custom_meta_field_id));
    const display = value => {
        const text = Array.isArray(value) ? value.join(', ') : value;
        return text === null || text === undefined || text === '' ? '—' : normalizeTextAssetText(text);
    };
    if (!fields.length) return <Typography.Text type="secondary">{t('no-configured-fields', 'No configured fields.')}</Typography.Text>;

    return <Descriptions bordered size="small" column={1} layout={layout}>
        {fields.map(field => {
            const custom = customFields.get(field.custom_meta_field_id);
            const values = custom ? (asset.custom_meta_values || []).filter(value => value.custom_meta_field_id === custom.id) : [];
            const value = custom ? values.map(value => value.relationship_asset?.redacted
                ? t('restricted-asset', 'Restricted asset')
                : value.relationship_asset?.filename || (value.text ?? value.number ?? value.date ?? value.value))
                : standardDisplayValue(field, asset, attrs);
            return <Descriptions.Item key={field.key} label={field.name}>
                <div style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere'}}>
                    {custom && renderCustomField && (asset.taggable || values.length) ? renderCustomField(custom)
                        : !custom && renderStandardField ? renderStandardField(field, value)
                            : display(value)}
                </div>
            </Descriptions.Item>;
        })}
    </Descriptions>;
}
